// QSelect renders its option and selected labels as HTML unless sanitized, and those labels are names people typed:
// lines, users, teams, tags, ring groups. Changes QSelect's prop defaults, so it must run before any select mounts. A
// select that needs HTML labels can still pass `:options-sanitize="false"`.
export function applySelectDefaults (QSelect) {
  const props = QSelect.options.props

  props.optionsSanitize.default = true
  props.displayValueSanitize.default = true
}
